import React, { ReactNode } from 'react';
import { Button } from '@cimpress/react-components';

export interface ConfirmDialogProps {
  children: ReactNode;
  confirm?: () => void;
  cancel?: () => void;
  hide: () => void;
}

// tslint:disable-next-line:function-name
export default function ConfirmDialog({
  children,
  confirm,
  cancel,
  hide,
}: ConfirmDialogProps) {
  const onConfirm = () => {
    if (confirm) {
      confirm();
    }
    hide();
  };
  const onCancel = () => {
    if (cancel) {
      cancel();
    }
    hide();
  };
  return <>
    <div>
      {children}
    </div>
    <div className="d--f jc--fe" style={{ marginTop: '1em' }}>
      <Button type="default" onClick={onCancel}>Cancel</Button>
      <Button type="primary" onClick={onConfirm} style={{ marginLeft: '1em' }}>Confirm</Button>
    </div>
  </>;
}
